import React from 'react';
import { BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';

import { AuthProvider } from '../providers/AuthProvider';
import { Home } from '../pages/Home';
import { Coupon } from '../pages/Coupon';
import { NotFound } from '../pages/NotFound';
import { DrawerProvider } from '../providers/DrawerProvider';
import { RulesAndFAQ } from '../pages/RulesAndFAQ';
import { MyAccount } from '../pages/MyAccount';
import { CodeProvider } from '../providers/CodeProvider';
import { Privacity } from '../pages/Privacity';

export const AppRouter = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route exact path="/" element={
            <DrawerProvider>
              <Home />
            </DrawerProvider>
          } />
          <Route exact path="/cupom" element={
              <CodeProvider>
                <Coupon />
              </CodeProvider>
            }
          />
          <Route exact path="/regulamento-e-faq" element={<RulesAndFAQ />} />
          <Route exact path="/minha-conta" element={<MyAccount />} />
          <Route exact path="/politica-de-privacidade" element={<Privacity />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </Router>
  )
}
